
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/author/[name]",
      function () {
        return require("private-next-pages/author/[name]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/author/[name]"])
      });
    }
  